import { HttpClient, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FinCenService {
  constructor(private http: HttpClient) {}

  getQuarterDatesReports(): Observable<string[]> {
    return this.http.get<string[]>('/api/fincen/getquarterdatesReports')
      .pipe(catchError(this.handleError));
  }

  createFinCenReport(date: string): Observable<any> {
    return this.http.post<any>('/api/fincen/create-report', { date })
      .pipe(catchError(this.handleError));
  }

  uploadFinCenFiles(formData: FormData): Observable<HttpEvent<any>> {
    return this.http.post('/api/Reports/UploadFencenFiles', formData, {
      reportProgress: true,
      observe: 'events'
    }).pipe(catchError(this.handleError));
  }

  private handleError(error: any): Observable<never> {
    const message = error?.error?.message || error?.message || 'An error occurred while processing your request';
    return throwError(() => new Error(message));
  }
}
